import { useToast } from '@/hooks/use-toast';

export const useEnhancedToast = () => {
  const { toast } = useToast();
  
  return {
    success: (message: string, title = "Success") => toast({
      title,
      description: message,
      className: "border-l-4 border-l-green-500 bg-gradient-to-r from-green-50 to-white dark:from-green-950 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
    
    showSuccess: (title: string, message?: string) => toast({
      title,
      description: message,
      className: "border-l-4 border-l-green-500 bg-gradient-to-r from-green-50 to-white dark:from-green-950 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
    
    error: (message: string, title = "Error") => toast({
      title,
      description: message,
      variant: "destructive",
      className: "border-l-4 border-l-red-500 bg-gradient-to-r from-red-50 to-white dark:from-red-950 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
    
    showError: (title: string, message?: string) => toast({
      title,
      description: message,
      variant: "destructive",
      className: "border-l-4 border-l-red-500 bg-gradient-to-r from-red-50 to-white dark:from-red-950 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
    
    info: (message: string, title = "Info") => toast({
      title,
      description: message,
      className: "border-l-4 border-l-copper bg-gradient-to-r from-copper/10 to-white dark:from-copper/20 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
    
    warning: (message: string, title = "Warning") => toast({
      title,
      description: message,
      className: "border-l-4 border-l-orange-500 bg-gradient-to-r from-orange-50 to-white dark:from-orange-950 dark:to-slate-900 text-slate-900 dark:text-slate-100 shadow-lg",
    }),
  };
};
